module.exports = __webpack_public_path__ + "static/img/jo.fec99700.svg";